<div *ngIf="isLoading" class="text-center py-10 text-gray-500 dark:text-gray-400">
  Loading project overview...
</div>

<div *ngIf="!isLoading && projectData" class="bg-background-light dark:bg-background-dark dark:text-white grid grid-cols-1 lg:grid-cols-3 gap-8 mt-8">

  <!-- LEFT SECTION -->
  <div class="lg:col-span-2 space-y-8">
    <div class="bg-white dark:bg-[#181C2A] p-6 rounded-xl shadow-sm flex items-start gap-6">
      <div
        class="w-16 h-16 flex items-center justify-center rounded-lg text-2xl font-medium
              bg-gray-100 text-green-600 dark:bg-gray-700 dark:text-green-400"
      >
        {{ projectData.name | initials }}
    </div>
      <div>
        <h2 class="text-2xl font-bold mb-2">{{ projectData.name }}</h2>
        <p class="text-base text-gray-600 dark:text-gray-400 leading-relaxed mb-2">
          {{ projectData.description || 'No description available.' }}
        </p>
        <div class="text-sm text-gray-500 dark:text-gray-400 space-y-1">
          <p><span class="font-medium text-gray-700 dark:text-gray-300">Created On:</span> {{ projectData.createdAt | date:'mediumDate' }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- RIGHT SECTION -->
  <div class="space-y-8">
    <div class="bg-white dark:bg-[#181C2A] p-6 rounded-xl shadow-sm">
      <h2 class="text-xl font-bold mb-4">Content Stats</h2>
      <div class="space-y-4">
        <div class="flex items-center justify-between p-4 bg-primary/10 dark:bg-primary/20 rounded-lg">
          <div class="flex items-center gap-3">
            <span class="material-symbols-outlined text-primary text-2xl">videocam</span>
            <p class="font-medium">Total Videos</p>
          </div>
          <p class="font-bold text-2xl text-primary">{{ projectData.totalVideos || 0 }}</p>
        </div>

        <div class="flex items-center justify-between p-4 bg-accent/10 dark:bg-accent/20 rounded-lg">
          <div class="flex items-center gap-3">
            <span class="material-symbols-outlined text-accent text-2xl">description</span>
            <p class="font-medium text-accent">Total Documents</p>
          </div>
          <p class="font-bold text-2xl text-accent">{{ projectData.totalDocuments || 0 }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
